import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-1 mb-5">
            <span className="font-serif text-2xl">A+Auto</span>
            <span className="text-[#D4AF37] font-serif text-2xl">Fleet</span>
          </div>
          <p className="text-white/50 text-sm max-w-sm leading-relaxed">
            Uber & Lyft-approved car rentals for rideshare and delivery drivers. Unlimited miles,
            insurance and maintenance included. Reserve online, sign your agreement, and drive.
          </p>
        </div>
        <div>
          <p className="overline mb-5">Explore</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/fleet" className="hover:text-white">The Fleet</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline mb-5">Concierge</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex items-center gap-2"><Phone size={14} className="text-[#D4AF37]" /> +1 (214) 608-1735</li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-[#D4AF37]" /> Aplusautofleet@gmail.com</li>
            <li className="flex items-center gap-2"><MapPin size={14} className="text-[#D4AF37]" /> Mansfield, TX</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center text-white/30 text-xs">
        <span>© {new Date().getFullYear()} A+Auto Fleet. All rights reserved.</span>
        <span className="hidden sm:inline text-white/15">·</span>
        <Link to="/admin/login" data-testid="footer-admin-link" className="text-white/30 hover:text-[#D4AF37] transition-colors">
          Admin
        </Link>
      </div>
    </footer>
  );
};
